<template>
  <div :class="$style.headerTopSection">
    <header
      :class="$style.sectionHeader"
    >
      Configuration settings
    </header>

    <GenericScimConnectorNewConfigButtons
      v-if="!isScimActive"
      :enableTestConnectionButton="enableTestConnectionButton"
    />
    <GenericScimConnectorUpdateConfigButtons
      v-if="isScimActive"
      :areCredentialsValid="enableTestConnectionButton"
    />
  </div>
</template>

<script>
import GenericScimConnectorNewConfigButtons from 'client/applications/scim/GenericScimConnectorNewConfigButtons.vue';
import GenericScimConnectorUpdateConfigButtons from 'client/applications/scim/GenericScimConnectorUpdateConfigButtons.vue';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';

export default {
  name: 'GenericScimConnectorConfigurationHeader',

  components: {
    GenericScimConnectorNewConfigButtons,
    GenericScimConnectorUpdateConfigButtons,
  },

  mixins: [IdentityManagementMixin],

  props: {
    enableTestConnectionButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style module>
@import 'css/IdentityManagementCommon.css';

@value ( jcGrey600 ) from '~css/brand-colors.css';

.headerTopSection {
  display: flex;
  justify-content: space-between;
}

.sectionHeader {
  color: jcGrey600;
  font-size: 20px;
  font-weight: bold;
}

.temporaryPlaceHolderButton {
  margin-left: 16px;
}
</style>
